import { Box, Button, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";

function QrScanner({ onScan, onClose, title = "مسح رمز QR" }) {
    const regionRef = useRef(null);
    const scannerRef = useRef(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;

        const start = async () => {
            try {
                const { Html5Qrcode } = await import('html5-qrcode');
                if (!active || !regionRef.current) return;

                const scanner = new Html5Qrcode('student-qr-reader');
                scannerRef.current = scanner;

                await scanner.start(
                    { facingMode: 'environment' },
                    { fps: 8, qrbox: { width: 220, height: 220 } },
                    (decoded) => {
                        onScan(decoded);
                        scanner.stop().catch(() => {});
                    },
                    () => {}
                );
            } catch (e) {
                setError('تعذر تشغيل الكاميرا. يمكنك إدخال الرمز يدوياً.');
            }
        };

        start();

        return () => {
            active = false;
            const scanner = scannerRef.current;
            if (scanner) {
                scanner.stop().catch(() => {});
                scanner.clear().catch(() => {});
            }
        };
    }, [onScan]);

    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>{title}</Typography>
            <Box id="student-qr-reader" ref={regionRef} sx={{ width: '100%', minHeight: 240 }} />
            {error && <Typography variant="caption" color="error">{error}</Typography>}
            {onClose && (
                <Button size="small" onClick={onClose} sx={{ mt: 1 }}>
                    إيقاف المسح
                </Button>
            )}
        </Box>
    );
}

export default QrScanner;
